import React from 'react';
import Button from '../../../molecules/buttons';

interface Props {
    cancelText?: string;
    submitText?: string;
    isLoading?: boolean;
}

const FormFooter: React.FC<Props> = (props) => {
  const {
    cancelText, submitText, isLoading,
  } = props;
  return (
    <div className="d-flex justify-content-end p-4 px-xl-5">
      <div style={cancelText ? { width: '200px', marginRight: '20px' } : { display: 'none' }}>
        <Button.Default
          type="button"
          label={cancelText}
          size="lg"
          outline
        />
      </div>
      <div style={submitText ? { width: '200px' } : { display: 'none' }}>
        <Button.Default
          type="submit"
          label={submitText}
          size="lg"
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default FormFooter;
